function padNumberWith0(value: number): string {
  return value.toString(10).padStart(2, '0');
}

function getPaddedDateValues(date: string | number | Date) {
  let dateObject: Date;

  if (date instanceof Date) {
    dateObject = date;
  } else if (typeof date === 'string') {
    if (date.indexOf('T') === -1) {
      date += 'T00:00:00';
    }
    dateObject = new Date(date);
  } else {
    dateObject = new Date(date);
  }

  const year = dateObject.getFullYear();
  const month = padNumberWith0(dateObject.getMonth() + 1); // month indexed from 0 to 11
  const day = padNumberWith0(dateObject.getDate());
  const hours = padNumberWith0(dateObject.getHours());
  const minutes = padNumberWith0(dateObject.getMinutes());
  const secondes = padNumberWith0(dateObject.getSeconds());

  return {
    year,
    month,
    day,
    hours,
    minutes,
    secondes
  };
}

export function getFormattedDate(date: string | number | Date, separator: string) {
  const paddedDate = getPaddedDateValues(date);

  return `${paddedDate.day}${separator}${paddedDate.month}${separator}${paddedDate.year}`;
}

export function getIsoFormattedDate(date: string | number | Date, withTime: boolean = false) {
  const paddedDate = getPaddedDateValues(date);

  let formattedDate = `${paddedDate.year}-${paddedDate.month}-${paddedDate.day}`;

  if (withTime) {
    formattedDate += `T${paddedDate.hours}:${paddedDate.minutes}:${paddedDate.secondes}`;
  }

  return formattedDate;
}

export function getFormattedDateTime(date: string | number | Date, dateSep = '/', timeSep = ':', dateTimeSep = ' ') {
  const paddedDate = getPaddedDateValues(date);

  return `${paddedDate.day}${dateSep}${paddedDate.month}${dateSep}${paddedDate.year}${dateTimeSep}${paddedDate.hours}${timeSep}${paddedDate.minutes}`;
}
export function getFormattedDateTimeWithoutSeparator(date: string | number | Date) {
  return getFormattedDateTime(date, '', '', '');
}
